import "./modules/svg/hui-svg.module.js";
import {HuiButton} from "./modules/buttons/hui-button.js";
import {HuiButtonGroup} from "./modules/buttons/hui-button-group.js";
import {HuiIcon} from "./modules/icons/hui-icon.js";
import {HuiMenuItem} from "./modules/menus/hui-menu-item.js";
import {HuiMenu} from "./modules/menus/hui-menu.js";
import {HuiMenuHeader} from "./modules/menus/hui-menu-header.js";
import {HuiProgressBar} from "./modules/progress/hui-progress-bar.js";
import {HuiBadge} from "./modules/badges/hui-badge.js";
import {HuiModal} from "./modules/modal/hui-modal.js";
import {HuiModalBody} from "./modules/modal/hui-modal-body.js";
import {HuiModalFooter} from "./modules/modal/hui-modal-footer.js";
import {HuiModalHeader} from "./modules/modal/hui-modal-header.js";
import {HuiCell} from "./modules/tables/hui-table-cell.js";
import {HuiTr} from "./modules/tables/hui-table-row.js";
import {HuiTable} from "./modules/tables/hui-table.js";
import {HuiTbody} from "./modules/tables/hui-tbody.js";
import {HuiThead} from "./modules/tables/hui-thead.js";
import {HuiTableContainer} from "./modules/tables/hui-table-container.js";
import {HuiAlert} from "./modules/alerts/hui-alert.js";
import {HuiAlertAction} from "./modules/alerts/hui-alert-action.js";
import {HuiInputCheckbox} from "./modules/inputs/hui-input-checkbox.js";
import {HuiAvatar} from "./modules/icons/hui-avatar.js";
import {HuiInputSwitch} from "./modules/inputs/hui-input-switch.js";
import {HuiBox, HuiBoxBody, HuiBoxFooter, HuiBoxHeader} from "./modules/content/hui-box.js";
import {HuiButtonDropdown} from "./modules/buttons/hui-button-dropdown.js";
import {HuiTabs} from "./modules/tabs/hui-tabs.js";
import {HuiTab} from "./modules/tabs/hui-tab.js";
import {HuiTabList} from "./modules/tabs/hui-tab-list.js";
import {HuiTabPanel} from "./modules/tabs/hui-tab-panel.js";
import {HuiList, HuiListItem} from "./modules/lists/hui-list.js";
import {HuiBreadcrumb, HuiBreadcrumbItem, HuiBreadcrumbLink} from "./modules/breadcrumbs/hui-breadcrumb.js";
import {HuiBadgeRing} from "./modules/badges/hui-badge-ring.js";
import {HuiInputBase} from "./modules/inputs/hui-input-base.js";
import {HuiInputText} from "./modules/inputs/hui-input-text.js";
import {HuiInputNumber} from "./modules/inputs/hui-input-number.js";
import {HuiInputSearch} from "./modules/inputs/hui-input-search.js";
import {HuiInputPhone} from "./modules/inputs/hui-input-phone.js";
import {HuiInputDatePicker} from "./modules/inputs/hui-input-date-picker.js";
import {HuiInputTextarea} from "./modules/inputs/hui-input-textarea.js";
import {HuiInputRadio} from "./modules/inputs/hui-input-radio.js";
import {HuiInputSelectWrapper} from "./modules/inputs/hui-input-select-wrapper.js";
import {HuiInputSelectLegacy} from "./modules/inputs/hui-input-select-legacy.js";
import {HuiMenuFooter} from "./modules/menus/hui-menu-footer.js";
import {HuiInputSlider} from "./modules/inputs/hui-input-slider.js";
import {HuiInputSliderRange} from "./modules/inputs/hui-input-slider-range.js";
import {HuiProgressTrack} from "./modules/progress/hui-progress-track.js";
import {HuiProgressGroupLine} from "./modules/progress/hui-progress-group-line.js";
import {HuiProgressGroup} from "./modules/progress/hui-progress-group.js";
import {HuiProgressLabel} from "./modules/progress/hui-progress-label.js";
import {HuiAccordion} from "./modules/accordion/hui-accordion.js";
import {HuiAccordionItem} from "./modules/accordion/hui-accordion-item.js";
import {HuiAccordionHeader} from "./modules/accordion/hui-accordion-header.js";
import {HuiAccordionPanel} from "./modules/accordion/hui-accordion-panel.js";
import {HuiInputPassword} from "./modules/inputs/hui-input-password.js";
import {HuiInputDateRange} from "./modules/inputs/hui-input-date-range.js";
import {HuiInputWeekDatePicker} from "./modules/inputs/hui-input-week-date-picker.js";
import {HuiInputTimePicker} from "./modules/inputs/hui-input-time-picker.js";
import {HuiDraggableItem} from "./modules/drag-drop/hui-draggable-item.js";
import {HuiDraggableContainer} from "./modules/drag-drop/hui-draggable-container.js";
import {HuiStepper} from "./modules/stepper/hui-stepper.js";
import {HuiStep} from "./modules/stepper/hui-step.js";
import {HuiStepButton} from "./modules/stepper/hui-step-button.js";
import {HuiStepSeparator} from "./modules/stepper/hui-step-separator.js";
import {HuiPaginator} from "./modules/paginator/hui-paginator.js";
import {HuiSkeleton} from "./modules/skeleton/hui-skeleton.js";
import {HuiToast} from "./modules/toasts/hui-toast.js";
import {HuiSeparator} from "./modules/separator/hui-separator.js";
import {HuiInputSelectorContainer} from "./modules/inputs/hui-input-selector-container.js";
import {HuiInputSelectorItem} from "./modules/inputs/hui-input-selector-item.js";
import {HuiPage} from "./modules/pages/hui-page.js";
import {HuiPageActions} from "./modules/pages/hui-page-actions.js";
import {HuiPageBody} from "./modules/pages/hui-page-body.js";
import {HuiPageContent, HuiPageContentAttribute} from "./modules/pages/hui-page-content.js";
import {HuiPageHeader} from "./modules/pages/hui-page-header.js";
import {HuiPageSubHeader} from "./modules/pages/hui-page-sub-header.js";
import {HuiPageTitle} from "./modules/pages/hui-page-title.js";
import {HuiPopover} from "./modules/popover/hui-popover.js";
import {HuiPopoverHeader} from "./modules/popover/hui-popover-header.js";
import {HuiPopoverFooter} from "./modules/popover/hui-popover-footer.js";
import {HuiPopoverContent} from "./modules/popover/hui-popover-content.js";
import {HuiPopoverBody} from "./modules/popover/hui-popover-body.js";
import {HuiPageStickyPanel} from "./modules/pages/hui-page-sticky-panel.js";
import {HuiPageFooter} from "./modules/pages/hui-page-footer.js";
import {HuiDialog} from "./modules/modal/hui-dialog.js";
import {HuiDialogHeader} from "./modules/modal/hui-dialog-header.js";
import {HuiDialogBody} from "./modules/modal/hui-dialog-body.js";
import {HuiDialogFooter} from "./modules/modal/hui-dialog-footer.js";
import {HuiAvatarGroup} from "./modules/icons/hui-avatar-group.js";
import {HuiInputOption} from "./modules/inputs/hui-input-option.js";
import {HuiInputSelect} from "./modules/inputs/hui-input-select.js";
import {HuiSelectedItem} from "./modules/inputs/hui-selected-item.js";
import {HuiSpinner} from "./modules/spinner/hui-spinner.js";

const huiModule = angular.module("hui", ['huiSvg']);

huiModule.directive('huiButton', HuiButton);
huiModule.directive('huiButtonGroup', HuiButtonGroup);
huiModule.directive('huiIcon', HuiIcon);
huiModule.directive('huiMenuItem', HuiMenuItem);
huiModule.directive('huiMenu', HuiMenu);
huiModule.directive('huiMenuHeader', HuiMenuHeader);
huiModule.directive('huiProgressBar', HuiProgressBar);
huiModule.directive('huiBadge', HuiBadge);
huiModule.directive('huiBadgeRing', HuiBadgeRing);
huiModule.directive('huiModal', HuiModal);
huiModule.directive('huiModalBody', HuiModalBody);
huiModule.directive('huiModalFooter',HuiModalFooter);
huiModule.directive('huiModalHeader', HuiModalHeader);
huiModule.directive('huiCell', HuiCell);
huiModule.directive('huiTr', HuiTr);
huiModule.directive('huiThead', HuiThead);
huiModule.directive('huiTbody', HuiTbody);
huiModule.directive('huiTable', HuiTable);
huiModule.directive('huiTableContainer', HuiTableContainer);
huiModule.directive('huiAlert', HuiAlert);
huiModule.directive('huiAlertAction', HuiAlertAction);
huiModule.directive('huiInputCheckbox', HuiInputCheckbox);
huiModule.directive('huiAvatar', HuiAvatar);
huiModule.directive('huiInputSwitch', HuiInputSwitch);
huiModule.directive('huiBox', HuiBox);
huiModule.directive('huiBoxHeader', HuiBoxHeader);
huiModule.directive('huiBoxBody', HuiBoxBody);
huiModule.directive('huiBoxFooter', HuiBoxFooter);
huiModule.directive('huiButtonDropdown', HuiButtonDropdown);
huiModule.directive('huiTabs', HuiTabs);
huiModule.directive('huiTab', HuiTab);
huiModule.directive('huiTabList', HuiTabList);
huiModule.directive('huiTabPanel', HuiTabPanel);
huiModule.directive('huiList', HuiList);
huiModule.directive('huiListItem', HuiListItem);
huiModule.directive('huiBreadcrumb', HuiBreadcrumb);
huiModule.directive('huiBreadcrumbItem', HuiBreadcrumbItem);
huiModule.directive('huiBreadcrumbLink', HuiBreadcrumbLink);
huiModule.directive('huiInputBase', HuiInputBase);
huiModule.directive('huiInputText', HuiInputText);
huiModule.directive('huiInputNumber', HuiInputNumber);
huiModule.directive('huiInputSearch', HuiInputSearch);
huiModule.directive('huiInputPhone', HuiInputPhone);
huiModule.directive('huiInputDatePicker', HuiInputDatePicker);
huiModule.directive('huiInputTextarea', HuiInputTextarea);
huiModule.directive('huiInputRadio', HuiInputRadio);
huiModule.directive('huiInputSelectWrapper', HuiInputSelectWrapper);
huiModule.directive('huiInputSelectLegacy', HuiInputSelectLegacy);
huiModule.directive('huiMenuFooter', HuiMenuFooter);
huiModule.directive('huiInputSlider', HuiInputSlider);
huiModule.directive('huiInputSliderRange', HuiInputSliderRange);
huiModule.directive('huiProgressTrack', HuiProgressTrack);
huiModule.directive('huiProgressGroupLine', HuiProgressGroupLine);
huiModule.directive('huiProgressGroup', HuiProgressGroup);
huiModule.directive('huiProgressLabel', HuiProgressLabel);
huiModule.directive('huiAccordion', HuiAccordion);
huiModule.directive('huiAccordionItem', HuiAccordionItem);
huiModule.directive('huiAccordionHeader', HuiAccordionHeader);
huiModule.directive('huiAccordionPanel', HuiAccordionPanel);
huiModule.directive('huiInputPassword', HuiInputPassword);
huiModule.directive('huiInputDateRange', HuiInputDateRange);
huiModule.directive('huiInputWeekDatePicker', HuiInputWeekDatePicker);
huiModule.directive('huiInputTimePicker', HuiInputTimePicker);
huiModule.directive('huiDraggableItem', HuiDraggableItem);
huiModule.directive('huiDraggableContainer', HuiDraggableContainer);
huiModule.directive('huiStepper', HuiStepper);
huiModule.directive('huiStep', HuiStep);
huiModule.directive('huiStepButton', HuiStepButton);
huiModule.directive('huiStepSeparator', HuiStepSeparator);
huiModule.directive('huiPaginator', HuiPaginator);
huiModule.directive('huiSkeleton', HuiSkeleton);
huiModule.directive('huiToast', HuiToast);
huiModule.directive('huiSeparator', HuiSeparator);
huiModule.directive('huiSelectorContainer', HuiInputSelectorContainer);
huiModule.directive('huiSelectorItem', HuiInputSelectorItem);
huiModule.directive('huiPage', HuiPage);
huiModule.directive('huiPageActions', HuiPageActions);
huiModule.directive('huiPageBody', HuiPageBody);
huiModule.directive('huiPageContent', HuiPageContent);
huiModule.directive('huiPageContent', HuiPageContentAttribute);
huiModule.directive('huiPageHeader', HuiPageHeader);
huiModule.directive('huiPageSubHeader', HuiPageSubHeader);
huiModule.directive('huiPageTitle', HuiPageTitle);
huiModule.directive('huiPopover', HuiPopover);
huiModule.directive('huiPopoverHeader', HuiPopoverHeader);
huiModule.directive('huiPopoverContent', HuiPopoverContent);
huiModule.directive('huiPopoverBody', HuiPopoverBody);
huiModule.directive('huiPopoverFooter', HuiPopoverFooter);
huiModule.directive('huiPageStickyPanel', HuiPageStickyPanel);
huiModule.directive('huiPageFooter', HuiPageFooter);
huiModule.directive('huiDialog', HuiDialog);
huiModule.directive('huiDialogHeader', HuiDialogHeader);
huiModule.directive('huiDialogBody', HuiDialogBody);
huiModule.directive('huiDialogFooter', HuiDialogFooter);
huiModule.directive('huiAvatarGroup', HuiAvatarGroup);
huiModule.directive('huiInputSelect', HuiInputSelect);
huiModule.directive('huiInputOption', HuiInputOption);
huiModule.directive('huiSelectedItem', HuiSelectedItem);
huiModule.directive('huiSpinner', HuiSpinner);

